export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.6.3-1346.07",
  commitId: "07e5d791fdfa94cd0a5eee9f5c9e40e19bdeecf6",
  commitTime: "2026-06-03T13:46:07.000Z",
});
